import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blog';
import { JsonLd, useSEO } from '../utils/seo';
export function Blog() {
  useSEO({
    title: 'Gravel, Driveway & Landscaping Guides | 206Gravel',
    description: 'Practical guides for choosing gravel, building driveways, improving drainage, and planning bulk material delivery in the Puget Sound area.',
    path: '/blog'
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-24 pb-20 bg-[#f2efe8] dark:bg-[#252423] min-h-screen" data-id="element-2357" data-mp="3uflqn2urco3l">
      <JsonLd data={{
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: '206Gravel Guides & Tips',
      url: 'https://206gravel.com/blog',
      blogPost: blogPosts.map(post => ({
        '@type': 'BlogPosting',
        headline: post.title,
        datePublished: post.date,
        image: post.image,
        url: `https://206gravel.com/blog/${post.slug}`,
        description: post.excerpt
      }))
    }} data-id="element-2358" data-mp="cykn523d1y7r" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2359" data-mp="2239ltfadcnwn">
        {/* Header mirrors the Materials Hub / Project Guides sections: accent
            rule, oversized two-tone heading, an eyebrow, and one line of
            orientation copy. */}
        <header className="mb-10 md:mb-12" data-id="element-2360" data-mp="2fx0jnqeqmjcj">
          <motion.div initial={{
          width: 0,
          opacity: 0
        }} animate={{
          width: 64,
          opacity: 1
        }} transition={{
          duration: 0.65,
          ease: [0.22, 1, 0.36, 1]
        }} className="mb-7 h-1 rounded-full bg-brand-orange" data-id="element-2361" data-mp="2fvzbput0qcz1" />
          <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-baseline md:gap-7" data-id="element-2362" data-mp="1s5mu1s7z11v9">
            <motion.h1 initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="font-heading text-5xl font-extrabold leading-[1.1] tracking-tight text-brand-charcoal dark:text-white md:text-6xl lg:text-7xl" data-id="element-2363" data-mp="1x7u9irs0f02c">
              Gravel <span className="font-black text-[#04A05C]" data-id="element-2364" data-mp="14hbmlil6ihq3">Guides</span>
            </motion.h1>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#17A348]" data-id="element-2365" data-mp="1iguj1e4mo4mk">
              — Tips &amp; how-tos
            </span>
          </div>
          <p className="max-w-2xl font-sub text-lg font-medium leading-relaxed tracking-wide text-brand-charcoal dark:text-white" data-id="element-2366" data-mp="ps5qi3hn17mf">
            Straight answers on picking the right material, building a driveway
            that lasts, fixing drainage, and planning a bulk delivery — written
            from what we haul every day around Puget Sound.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2367" data-mp="727fbeijmyek">
          {blogPosts.map((post, idx) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white dark:bg-[#333333] rounded-2xl overflow-hidden shadow-sm border border-stone-200 dark:border-white/10 hover:shadow-md transition-shadow flex flex-col" data-id="element-2368" data-mp="23mhflqrkqta" data-mpi={idx}>
              <Link to={`/blog/${post.slug}`} className="block aspect-video overflow-hidden" data-id="element-2369" data-mp="28rd51pi7b87f">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-2370" data-mp="2wgxwyxwc1fsu" />
              </Link>
              <div className="p-6 flex flex-col flex-grow" data-id="element-2371" data-mp="31f98re66u0dp">
                <p className="text-sm text-brand-muted dark:text-stone-400 italic mb-2" data-id="element-2372" data-mp="2nh2iaj3kj2o2">
                  {post.date}
                </p>
                <Link to={`/blog/${post.slug}`} data-id="element-2373" data-mp="2sdj6fdarph15">
                  <h2 className="text-2xl font-bold text-brand-charcoal dark:text-white mb-3 hover:text-brand-orange transition-colors" style={{
                fontFamily: "Cabin, sans-serif",
                fontSize: "24px",
                fontWeight: "700"
              }} data-id="element-2374" data-mp="1c0kut8hy8adk">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-brand-muted dark:text-stone-300 text-sm leading-relaxed flex-grow" data-id="element-2375" data-mp="1rilwgd24ivxb">
                  {post.excerpt}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </main>;
}